module.exports = __webpack_public_path__ + "static/androidBannerInsurance-43020571397a92b57154a2f735a5e3fa.jpg";